<template>
  <div>
    <div class="headCont">
      <div class="addBoxs">
        <div class="addBox dis-cent" @click="addClick">
          <div class="iconfont icon-add"></div>
          <div class="text">发布职位</div>
        </div>
        <div class="gxBox" @click="shuaxinClick">
          <div class="text">修改岗位后没变化？点击更新</div>
        </div>
      </div>
      <div class="slelectCont">
        <div class="ssBox">
          <input
            type="text"
            placeholder="搜索"
            v-model="searChTxt"
            @keyup.enter="searchClick"
          />
          <div
            class="iconfont icon-search search dis-cent"
            @click="searchClick"
          ></div>
        </div>
        <!-- <div class="lxBox dis-cent">
          <div class="name">全部职位类型</div>
          <div class="iconfont icon-unfold unfold"></div>
        </div> -->
      </div>
    </div>
    <div class="typeList">
      <div class="typeBox">
        <div
          class="type"
          v-for="(item, index) in typeList"
          :class="item.id == typeOn ? 'on' : ''"
          @click="typeClick(item.id)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="timeBtns">
        <div class="time" v-if="times">下次可刷新时间：{{ times }}后</div>
        <div class="timeBtn" v-if="!times && !xzSlect" @click="plClick(1)">
          批量刷新
        </div>
        <div class="timeBtn" v-if="!times && !xzSlect" @click="dxClick">
          多选刷新
        </div>
        <div class="timeBtn1" v-if="!times && xzSlect" @click="qxClick">
          取消
        </div>
        <div class="timeBtn" v-if="!times && xzSlect" @click="plClick">
          确定刷新
        </div>
      </div>
    </div>
    <div class="content">
      <Kong v-if="list.length == 0" />
      <div
        class="contBox"
        v-for="(item, index) in list"
        :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
      >
        <div class="contBoxLeft" :class="!xzSlect ? 'w100' : ''">
          <div class="txtCont">
            <div class="name">
              {{ item.jobs_name }} <span v-if="item.jp > 0">[急聘]</span>
            </div>
            <div class="textBox">
              <div class="txt">{{ item.district_cn }}</div>
              <div class="shu"></div>
              <div class="txt">
                {{ item.experience_cn ? item.experience_cn : "不限" }}
              </div>
              <div class="shu"></div>
              <div class="txt">{{ item.education_cn }}</div>
              <div class="shu"></div>
              <div class="txt">
                {{
                  item.minwage == 0 && item.maxwage == 0
                    ? "面议"
                    : item.minwage + "-" + item.maxwage + "K"
                }}
              </div>
            </div>
          </div>
          <div class="lxCont">
            <div
              class="box"
              @click="toudiClick(item.id, item.jobs_name)"
              style="cursor: pointer"
            >
              <div
                class="num"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                <span>{{ item.resumeslength ? item.resumeslength : 0 }}</span>
              </div>
              <div
                class="name"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                投递简历
              </div>
            </div>
            <div
              class="box"
              @click="goutongClick(item.id, item.jobs_name)"
              style="cursor: pointer"
            >
              <div
                class="num"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                {{ item.chatlength }}
              </div>
              <div
                class="name"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                沟通人数
              </div>
            </div>
            <div
              class="box"
              @click="liulanClick(item.id, item.jobs_name)"
              style="cursor: pointer"
            >
              <div
                class="num"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                {{ item.readlength }}
              </div>
              <div
                class="name"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                浏览人数
              </div>
            </div>
            <div
              class="box"
              @click="shoucangClick(item.id, item.jobs_name)"
              style="cursor: pointer"
            >
              <div
                class="num"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                {{ item.favoritelength }}
              </div>
              <div
                class="name"
                :class="item.display == 2 || item.audit == 3 ? 'hui' : ''"
              >
                收藏人数
              </div>
            </div>
          </div>
          <div class="zhuangtai">
            <div
              class="yuan"
              :class="item.display == 2 || item.audit == 3 ? 'huiyuan' : ''"
            ></div>
            <div class="name">
              {{ item.display == 1 ? "开放中" : "已关闭" }}
            </div>
          </div>
          <div class="funCont">
            <div class="box">
              <div
                class="textBox"
                v-if="item.display == 1"
                @click="peoClick(item.id)"
              >
                适配人才({{ item.shipei }})
              </div>
              <div class="text" @click="bjClick(item.id, item.display)">
                编辑
              </div>
              <div class="text" @click="jumpClick(item.id, item.display)">
                职位预览
              </div>
              <!-- <div class="text" @click="kfClick(item.id, item.display, index)">
              {{
                item.audit == 3
                  ? "审核失败"
                  : item.display == 1
                    ? "关闭职位"
                    : "开放职位"
              }}
            </div> -->
            </div>
            <div class="cont">
              <!-- <div class="txt" v-if="refresh > 0" @click="jobRefreClick(item.id)">
              刷新职位<span v-if="item.times != 0">({{ item.times }}后可以刷新)</span>
            </div> -->
              <div class="txt" @click="kfClick(item.id, item.display, index)">
                {{
                  item.audit == 3
                    ? "审核失败"
                    : item.display == 1
                    ? "关闭职位"
                    : "开放职位"
                }}
              </div>
              <div class="shu"></div>
              <div class="txt">
                <a-popconfirm
                  title="是否确定删除"
                  ok-text="是"
                  cancel-text="否"
                  @confirm="delClick(item.id, item.display)"
                >
                  删除
                </a-popconfirm>
              </div>
            </div>
          </div>
        </div>
        <div class="contBoxRit" v-if="xzSlect">
          <div
            class="kuang dis-cent"
            v-if="item.display != 2 && item.audit != 3"
            :class="item.select ? 'on' : ''"
            @click="kClick(index, item.id)"
          >
            <div class="iconfont icon-right" v-if="item.select"></div>
          </div>
        </div>
      </div>
      <div class="fenye" v-if="totalCount > 8">
        <a-pagination
          :default-current="page.pageNo"
          v-model="page.pageNo"
          :total="totalCount"
          :page-size="8"
          @change="pageOnChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Kong from "../../component/kong.vue";

export default {
  components: {
    Kong,
  },
  name: "",
  data() {
    return {
      typeOn: 0,
      typeList: [
        {
          id: 0,
          name: "全部职位",
        },
        {
          id: 1,
          name: "开放中",
        },
        {
          id: 2,
          name: "待开放",
        },
        // {
        //   id: 3,
        //   name: "审核失败",
        // },
      ],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 8,
        type: 1,
      },
      list: [],
      totalCount: 0,
      searChTxt: "",
      time: "",
      refresh: 0,
      times: "",
      ids: [],
      xzSlect: false,
    };
  },
  created() {
    this.vipGet();
    this.company_workget();
  },
  methods: {
    kClick(i, id) {
      this.list[i].select = !this.list[i].select;
      if (this.list[i].select) {
        this.ids.push(id);
      } else {
        this.ids.splice(i, 1);
      }
      console.log(this.ids);
    },
    dxClick() {
      this.xzSlect = true;
    },
    qxClick() {
      this.ids = [];
      this.xzSlect = false;
    },
    shuaxinClick() {
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    company_workget() {
      this.$get("/nozzle/web/company_vip").then((res) => {
        console.log(res);
        this.company_workInfo = res;
      });
    },
    jumpClick(id, dis) {
      // this.$router.push({
      //   path: "/gongsi/zhiweiyulan",
      //   query: {
      //     id,
      //     kaifang: dis,
      //   },
      // });
      window.open("#/gongsi/zhiweiyulan?kaifang=" + dis + "&id=" + id);
    },
    plClick(type) {
      let ids = this.ids.join(",");
      if (!ids && type != 1) {
        this.$message.error("请至少选择一个岗位");
        return;
      }
      this.$post("/nozzle/web/job_refresh", {
        jobs_id: ids,
      }).then((res) => {
        if (res.data.status == 1) {
          this.ids = [];
          this.xzSlect = false;
          this.$message.success("刷新成功");
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    vipGet() {
      this.$get("/nozzle/web/my_vip").then((res) => {
        console.log(res);
        this.refresh = res.data.refresh;
        this.listGet();
      });
    },
    jobRefreClick(id) {
      this.$post("/nozzle/web/job_refresh", {
        id,
      }).then((res) => {
        if (res.data.status == 1) {
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    goutongClick(id) {
      window.open("#/gongsi/message?job_id=" + id);
    },
    liulanClick(id, name) {
      window.open("#/gongsi/liulan?name=" + name + "&id=" + id);
    },
    shoucangClick(id, name) {
      window.open("#/gongsi/shoucang?name=" + name + "&id=" + id);
    },
    toudiClick(id) {
      window.open("#/gongsi/tjrcIndex?type=3&id=" + id);
    },
    peoClick(id) {
      // this.$router.push({
      //   path: "/gongsi/tjrcIndex",
      //   query: {
      //     type: 1,
      //     id: id,
      //   },
      // });
      window.open("#/gongsi/tjrcIndex?type=1&id=" + id);
    },
    delClick(id, dis) {
      let table = "";
      if (dis == 1) {
        table = "post_job";
      }
      if (dis == 2) {
        table = "post_job_tmp";
      }
      this.$post("/common/delete", {
        id,
        table: table,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.page.pageNo = 1;
          this.totalCount = 0;
          if (dis == 1) {
            this.listGet();
          }
          if (dis == 2) {
            this.bkflistGet();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    typeClick(id) {
      this.typeOn = id;
      if (id == 0) {
        this.page.display = "";
        this.page.audit = "";
      }
      if (id == 1) {
        this.page.display = id;
        this.page.audit = "";
      }
      if (id == 2) {
        this.page.display = "";
        this.page.audit = "";
      }
      // if (id == 3) {
      //   this.page.display = "";
      //   this.page.audit = id;
      // }
      this.page.pageNo = 1;
      this.totalCount = 0;
      if (id == 1 || id == 0) {
        this.listGet();
      }
      if (id == 2) {
        this.bkflistGet();
      }
    },
    searchClick() {
      this.page.jobs_name = this.searChTxt;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.listGet();
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    bjClick(id, dis) {
      this.$router.push({
        path: "/gongsi/addZhiwei",
        query: {
          type: 0,
          id,
          kaifang: dis,
        },
      });
    },
    kfClick(id, dis, i) {
      let display;
      if (dis == 1) {
        display = 2;
      } else if (dis == 2) {
        display = 1;
      }
      this.$post("/nozzle/web/company_job_display", {
        id,
        display,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.list[i].display = display;
          if (dis == 1) {
            this.listGet();
          }
          if (dis == 2) {
            if (this.typeOn == 0) {
              this.listGet();
            } else {
              this.bkflistGet();
            }
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_job", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          let startDate = this.$moment();
          let time = this.$moment(res.data[0].refreshtime * 1000).format();
          time = this.$moment(time).add(this.refresh, "hours");
          if (time.diff(startDate, "minutes") > 0) {
            this.times = this.toHourMinute(time.diff(startDate, "minutes"));
          } else {
            this.times = 0;
          }
          console.log(this.times);

          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.select = false;
            e.jp = Number(this.timeXcGet(e.worry_end_time));
            // let time = this.$moment(e.refreshtime * 1000).format();
            // time = this.$moment(time).add(this.refresh, "hours");
            // if (time.diff(startDate, "minutes") > 0) {
            //   e.times = this.toHourMinute(time.diff(startDate, "minutes"));
            // } else {
            //   e.times = 0
            // }
            // console.log(e.times);
          }
          this.list = res.data;
          this.fzGet();
        } else {
          this.list = [];
        }
      });
    },
    fzGet() {
      if (this.ids.length > 0) {
        for (let j = 0; j < this.ids.length; j++) {
          const ej = this.ids[j];
          for (let i = 0; i < this.list.length; i++) {
            const e = this.list[i];
            if (ej == e.id) {
              this.list[i].select = true;
            }
          }
        }
      }
    },
    bkflistGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/company_job_tmp", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          let startDate = this.$moment();
          let time = this.$moment(res.data[0].refreshtime * 1000).format();
          time = this.$moment(time).add(this.refresh, "hours");
          if (time.diff(startDate, "minutes") > 0) {
            this.times = this.toHourMinute(time.diff(startDate, "minutes"));
          } else {
            this.times = 0;
          }
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.jp = Number(this.timeXcGet(e.worry_end_time));
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
    toHourMinute(minutes) {
      return Math.floor(minutes / 60) + "小时" + (minutes % 60) + "分";
      // 也可以转换为json，以方便专外部使用属
      // return {hour:Math.floor(minutes/60),minute:(minutes%60)};
    },
    timeXcGet(time) {
      const now = this.$moment();
      let jptime = this.$moment(time * 1000).format();
      jptime = this.$moment(jptime);
      jptime = this.$moment.duration(jptime.diff(now));
      return jptime.asHours().toFixed(1);
    },
    addClick() {
      this.$router.push({
        path: "/gongsi/addZhiwei",
        query: {
          type: 0,
          kaifang: 1,
        },
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.headCont {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  margin-top: 10px;

  .addBoxs {
    display: flex;
    align-items: center;
  }
  .gxBox {
    display: flex;
    align-items: center;
    height: 35px;
    border-radius: 5px;
    background-color: #e70b0b;
    color: #fff;
    padding: 0 15px;
    cursor: pointer;
    margin-left: 15px;
  }
  .addBox {
    display: flex;
    align-items: center;
    height: 35px;
    width: 110px;
    border-radius: 5px;
    background-color: #1a78ec;
    color: #fff;
    padding-right: 5px;
    cursor: pointer;

    .icon-add {
      font-weight: 600;
    }

    .text {
      margin-left: 5px;
    }
  }

  .slelectCont {
    display: flex;
    align-items: center;

    .ssBox {
      height: 35px;
      background-color: #fff;
      width: 220px;
      border-radius: 5px;
      display: flex;

      input {
        width: calc(100% - 35px);
        box-sizing: border-box;
        padding-left: 15px;
      }

      .search {
        width: 35px;
        height: 35px;
        color: #9c9c9c;
        font-size: 18px;
      }
    }

    .lxBox {
      margin-left: 20px;
      height: 35px;
      width: 140px;
      background-color: #fff;
      border-radius: 5px;
      cursor: pointer;
      color: #666;

      .unfold {
        font-size: 14px;
        margin-left: 5px;
      }
    }
  }
}

.typeList {
  height: 50px;
  align-items: center;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;

  .typeBox {
    display: flex;
    align-items: center;

    .type {
      padding: 3px 15px;
      cursor: pointer;
      border-radius: 5px;
    }

    .on {
      background-color: #e1ecfa;
      color: #1a78ec;
      font-weight: 600;
    }
  }
  .timeBtns {
    display: flex;
  }
  .timeBtn {
    background-color: #e40505;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 15px;
  }
  .timeBtn1 {
    background-color: #929292;
    color: #fff;
    padding: 5px 10px;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 15px;
  }
}

.content {
  width: 100%;
  margin: auto;
  margin-top: 8px;

  .contBox {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    .contBoxLeft {
      display: flex;
      align-items: center;
      width: calc(100% - 40px);
      background-color: #fff;
      border-radius: 10px;
      padding: 20px 30px;
    }
    .w100 {
      width: 100%;
    }
    .contBoxRit {
      width: 40px;
      display: flex;
      justify-content: flex-end;
      .kuang {
        width: 20px;
        height: 20px;
        border-radius: 5px;
        border: 1px solid #c9c9c9;
        cursor: pointer;
      }
      .on {
        background-color: #1a78ec;
        color: #fff;
        border: 1px solid #1a78ec;
      }
    }
    .txtCont {
      width: 290px;
      height: 55px;

      .name {
        font-size: 16px;

        span {
          font-size: 14px;
          margin-left: 10px;
          color: #ec1a1a;
        }
      }

      .textBox {
        display: flex;
        align-items: center;
        font-size: 13px;
        color: #9c9c9c;
        margin-top: 10px;

        .shu {
          width: 1px;
          height: 12px;
          background-color: #e0e0e0;
          margin: 0 10px;
        }
      }
    }

    .lxCont {
      width: 330px;
      display: flex;
      align-items: center;

      .box {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        margin-right: 25px;

        .num {
          color: #000;
          font-size: 16px;
          margin-bottom: 6px;

          span {
            font-weight: 600;
            color: #1a78ec;
          }
        }

        .name {
          font-size: 12px;
          color: #5d6674;
        }
      }
    }

    .zhuangtai {
      display: flex;
      align-items: center;
      width: 70px;

      .yuan {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #1a78ec;
        margin-right: 5px;
      }
    }

    .funCont {
      width: calc(100% - 70px - 300px - 320px);

      .box {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .text {
          margin-left: 15px;
          color: #1a78ec;
          cursor: pointer;
        }

        .textBox {
          background-color: #1a78ec;
          color: #fff;
          padding: 3px 6px 3px 8px;
          border-radius: 5px;
          cursor: pointer;
        }

        .more {
          font-size: 24px;
          color: #9c9c9c;
          cursor: pointer;
        }
      }

      .cont {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        font-size: 13px;
        color: #777;
        padding-top: 3px;

        .shu {
          margin: 0 10px;
          width: 1px;
          height: 14px;
          background-color: #70757c;
        }

        .txt {
          cursor: pointer;
        }
      }
    }
  }

  .hui {
    color: #9c9c9c !important;
  }

  .huiyuan {
    background-color: #9c9c9c !important;
  }
}
</style>
